export default {
  newReservations: null
};
